import React from 'react'

interface InsightsProps {
  dateRange: [string | undefined, string | undefined]
  setDateRange: (date: [string | undefined, string | undefined]) => void
  trainingIds: string[]
  setTrainingIds: (trainingIds: string[]) => void
  trainingClassesIds: string[]
  setTrainingClassesIds: (trainingIds: string[]) => void
  teamIds: string[]
  setTeamIds: (teamIds: string[]) => void
}

const store = React.createContext<InsightsProps | null>(null)
export const Provider = store.Provider

export const useFilters = (): InsightsProps => {
  const context = React.useContext(store)

  if (!context) {
    throw new Error('useFilters must be used within an Insights Provider')
  }

  return context
}
